import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Layout from '../Layout';
import Page from '../Page';
import posts from '../../core/posts';
import postsByIndex from '../../core/postsByIndex';
import PostFooter from '../PostFooter';
import s from './APost.css';

const makeFullPath = (post) => {
  if (!post || post.hide) {
    return;
  }
  return `/posts${post.path}`;
};

const nextValidPost = (index, incr) => {
  let res = index + incr;
  while (postsByIndex[res] !== undefined && postsByIndex[res].hide) {
    res += incr;
  }
  return postsByIndex[res];
};

class APost extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    path: PropTypes.string.isRequired,
  };

  render() {
    const post = posts[this.props.path];
    const title = post.title;
    const index = post.index;
    const previousPost = nextValidPost(index, -1);
    const nextPost = nextValidPost(index, 1);
    const previousPath = makeFullPath(previousPost);
    const nextPath = makeFullPath(nextPost);
    return (
      <Layout>
        <Page title={title} date={post.date} interests={post.interests}>
          {this.props.children}
          <PostFooter previousPath={previousPath} nextPath={nextPath} />
        </Page>
      </Layout>
    );
  }
}

export default withStyles(s)(APost);



// WEBPACK FOOTER //
// src/components/APost/APost.js